import React from 'react';
import ReactDOM from 'react-dom/client';
import CollapsibleSidebar from '../components/CollapsibleSidebar'; // Adjust path if needed


const TestPage = () => (
  <div>
    <h1>Test Sidebar</h1>
    <CollapsibleSidebar />
  </div>
);

export default TestPage;